export const ArtistInfo = [
    {
        'name': 'Johannes Brenke',
        'image': 'JohannesBrenke.jpg',
        'aspectRatio': '393 / 500',
        'description': '' +
            'Altenburg Host\n' +
            'Trompeten Museum, Bad Säckingen \n(director, retired)'
    },
    {
        'name': 'Friedemann Immer',
        'image': 'FriedemannImmer.jpg',
        'aspectRatio': '1 / 1',
        'description' :
            'Altenburg Judge\n' +
            'Hochschule für Musik und Tanz Köln\nSweelinck Conservatorium Amsterdam (retired)',
    },
    {
        'name': 'Susan Williams',
        'image': 'SusanWilliams.jpg',
        'aspectRatio': '81 / 100',
        'description':
            'Altenburg Judge\n' +
            'Royal Conservatorium, The Hague\nUniversity of the Arts, Bremen'

    },
    {
        'name': 'Jean-François Madeuf',
        'image': 'Jean-FrançoisMadeuf.jpg',
        'aspectRatio': '3 / 4',
        'description':
            'Altenburg Judge\n' +
            'Conservatoire National Supérieur de Musique of Lyon\nSchola Cantorum Basiliensis\nConservatoire National Supérieur de Musique in Paris'
    },
    {
        'name': 'Jason Dovel',
        'image': 'JasonDovel.jpg',
        'aspectRatio': '2 / 3',
        'description': 'Altenburg Judge\nUniversity of Kentucky',
        // eslint-disable-next-line no-useless-concat
    },
    {
        'name': 'Stanley Curtis',
        'image': 'StanleyCurtis.jpg',
        'aspectRatio': '9 / 13',
        'description': 'Altenburg Judge\n' +
            'Colorado State University\n'
    },
]